(function(){
  function init(root){
    if(!root || root.dataset.mialicaReady==='1') return;
    root.dataset.mialicaReady='1';

    root.querySelectorAll('.m-reveal').forEach(function(el){
      if('IntersectionObserver' in window){
        var io=new IntersectionObserver(function(entries,obs){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');obs.unobserve(entry.target);}});},{threshold:.1});
        io.observe(el);
      } else { el.classList.add('is-visible'); }
    });

    root.querySelectorAll('.m-faq-question').forEach(function(btn){
      btn.addEventListener('click',function(){
        var item=btn.closest('.m-faq-item');
        var single=btn.closest('[data-single-open="true"]');
        if(single && !item.classList.contains('is-open')){
          single.querySelectorAll('.m-faq-item.is-open').forEach(function(openItem){openItem.classList.remove('is-open');openItem.querySelector('.m-faq-question').setAttribute('aria-expanded','false');});
        }
        item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded',item.classList.contains('is-open') ? 'true' : 'false');
      });
    });
  }

  function initAll(){document.querySelectorAll('.mialica-section').forEach(init);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initAll);}else{initAll();}
  document.addEventListener('shopify:section:load',function(e){init(e.target.querySelector('.mialica-section') || e.target);});
})();
